import { code } from "@spscommerce/utils";

export const SpsScrollableContainerExamples = {
    basic: {
        label: "Basic",
        description: "basic scrollable container",
        examples: {
            text: {
                jsx: code`
                    <SpsCard>
                        <SpsScrollableContainer maxHeight='100px'>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
                                sit amet molestie metus. Phasellus dignissim interdum arcu. Sed
                                in nunc id sapien porta mollis eleifend nec mauris. Nulla
                                molestie pulvinar velit eget fringilla. Pellentesque habitant
                                morbi tristique senectus et netus et malesuada fames ac turpis
                                egestas. Nam eu sem ut neque condimentum tempor. Integer
                                bibendum in velit at consectetur. Nunc ut velit ac magna sodales
                                tempor. Ut tempor rhoncus mi, eget feugiat nisi finibus at.
                                Pellentesque habitant morbi tristique senectus et netus et
                                malesuada fames ac turpis egestas. Vestibulum nunc ipsum,
                                elementum consectetur urna a, sodales pellentesque nibh. Nullam
                                in dui dolor. Vivamus sapien enim, tristique accumsan finibus
                                nec, fringilla eget tellus. Duis sed pulvinar ipsum. Donec
                                convallis aliquet dui, nec ullamcorper nulla tincidunt ac. Fusce
                                tempus neque sit amet libero vestibulum maximus. Praesent id dui
                                sed diam scelerisque pretium id vitae ante. Sed ullamcorper
                                ligula quis mi vehicula, in interdum purus suscipit.
                                Pellentesque venenatis velit nunc, quis tincidunt ligula egestas
                                id. Praesent sollicitudin et mauris et auctor. Nullam diam erat,
                                tincidunt at odio non, tincidunt laoreet quam. In consequat
                                pulvinar sapien vel varius. Suspendisse potenti. Aenean pharetra
                                felis sit amet tempus consequat. Donec eu molestie mauris. Nunc
                                scelerisque ex id vehicula semper. Nunc eu interdum ante. Etiam
                                in metus ante. Nulla ac turpis vel sem fermentum mattis. Nam
                                elit mi, pretium a tristique vitae, vestibulum id tellus. In
                                vitae nisl lectus. Sed fringilla eget velit quis aliquet.
                                Vestibulum euismod, leo ut egestas dictum, mi quam euismod
                                velit, nec iaculis elit mi a orci. Duis volutpat purus lacus. Ut
                                sit amet semper ipsum. Sed aliquam, quam ac placerat facilisis,
                                nulla odio vulputate erat, id condimentum sem arcu vel turpis.
                                Fusce finibus tortor ac viverra semper. Pellentesque convallis
                                mi sed metus finibus molestie. Duis vehicula dolor consequat
                                placerat sollicitudin. Phasellus sed sagittis ligula, in
                                molestie velit. In scelerisque maximus metus, ac convallis nisi
                                dignissim non.
                            </p>
                        </SpsScrollableContainer>
                    </SpsCard>
                `
            },
            components: {
                react: code`
                    function Component() {
                        function buildTags() {
                            let tagNames = [];
                            for (let i = 0; i < 150; i++) {
                                tagNames.push('tagName ' + i);
                            }
                            return tagNames;
                        }
                        return <SpsCard>
                            <SpsScrollableContainer maxHeight='8.5rem'>
                                {buildTags().map((name, index) => {
                                    return (
                                        <SpsClickableTag key={index} className="mt-1 ml-1">
                                            {name}
                                        </SpsClickableTag>
                                    );
                                })}
                            </SpsScrollableContainer>
                        </SpsCard>
                    }
                `
            },
        },
    },
};
